import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
const AuthRoute = (props) => {
  const { component: Component, auth, render, classes, ...rest } = props;
  const authenticated = window.localStorage.getItem("token");
  console.log('vvvvvvvvvvvvvvvv33333333333')

  return (
    <Route
      {...rest}
      render={(props) =>
        !authenticated ? (
          <div>
            <Component {...props} />
          </div>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

AuthRoute.propTypes = {
  auth: PropTypes.object,
  render: PropTypes.func,
  classes: PropTypes.any,
};

const mapStateToProps = ({ auth }) => ({ auth });

const withStore = connect(mapStateToProps);

export default withStore(AuthRoute);
